<template>
  <div class="home-container">
    <div class="home-hero">
      <div class="home-hero1">
        <div class="home-container01">
          <h1 class="home-hero-sub-heading">
            <span>Kanadankarhumatkat.fi</span>
            <br />
          </h1>
          <span class="home-hero-sub-heading1">
            <span>Opastettuja karhunmetsästysmatkoja Kanadaan.</span>
            <br />
            <br />
          </span>
        </div>
      </div>
    </div>
    <div class="home-details">
      <div class="home-details1">
        <div class="home-container02">
          <span class="home-text05 sectionTitle">
            <span>karhualue</span>
            <br />
          </span>
          <h2 class="home-details-heading heading2">Pohjois-Ontario</h2>
          <span class="home-details-sub-heading">
            <span>
              Ontarion karhukanta on kasvanut 2010-luvulla lähestyen jo 160 000
              yksilöä ja kevätmetsästyksen myötä karhujen määrä on hallinnassa.
              Alue on erinomaista erämaata soveltuvuudeltaan karhun elinoloihin.
            </span>
            <br />
            <br />
            <span>
              Gathering Lake- järven ympäristössä on yhden miljoonan hehtaarin
              yhtenäinen jahtialue sekä satoja kilometrejä sorateitä, joita omalla
              tiekarhulla pidetään liikennöitävässä kunnossa. Erämainen alue
              vaatii kuitenkin maastoautot, koska myrskyt, sateet ja majavien
              kaatamat puut tekevät välillä mielenkiintoisia yllätyksiä
              matkantekoon.
            </span>
          </span>
        </div>
        <img alt="image" src="/ontario-400h.jpeg" class="home-details-image" />
      </div>
    </div>
    <div class="home-details2">
      <div class="home-details3">
        <div class="home-container03">
          <span class="home-text12 sectionTitle">
            <span>Kalastus</span>
            <br />
          </span>
          <h2 class="home-details-heading1 heading2">Pohjois-Ontario</h2>
          <span class="home-details-sub-heading1">
            <span class="home-text15">
              Rannassa on nylkyvajat sekä kalankäsittelytilat, juokseva vesi sekä
              24 h aggregaattivirralla varustettu pakastin niin kaloille, lihoille
              kuin trofeetaljoillekin.
            </span>
            <br />
            <br />
            <span>
              Myös kalastuksessa tarvittavat täkykalat “minnows” löytyvät paikan
              päältä, koska lähimpään kauppaan ja asutukseen on 75 km matka.
            </span>
            <br />
          </span>
        </div>
        <img alt="image" src="/kalastus-400h.jpeg" class="home-details-image1" />
      </div>
    </div>
    <div class="home-pricing">
      <div class="home-pricing1">
        <div class="home-container04">
          <div class="home-pricing-card">
            <div class="home-container05">
              <span class="home-text20 heading3">PER metsästäjä</span>
              <span class="home-basic-plan-description">
                Hintaan ei sisälly lennot, trofeemaksut, muut henkilökohtaiset
                tilatut ruokailut ja menot, Ontarion karhulupa (250 CAD) eikä
                kalastusluvat (alkaen 25CAD)
              </span>
            </div>
            <div class="home-container06">
              <span class="home-basic-plan-pricing">4 300,00 €</span>
            </div>
            <div class="home-container07">
              <div class="home-container08">
                <span class="home-text21">✔</span>
                <span class="home-text22">
                  Sisältää yhden mustakarhun kaatoluvan
                </span>
              </div>
              <div class="home-container09">
                <span class="home-text23">✔</span>
                <span class="home-basic-plan-features">
                  Yöpymiset matkan aikana
                </span>
              </div>
              <div class="home-container10">
                <span class="home-text24">✔</span>
                <span class="home-basic-plan-features1">
                  Auton vuokraus matkalle ja käyttö perillä
                </span>
              </div>
              <div class="home-container11">
                <span class="home-text25">✔</span>
                <span class="home-basic-plan-features2">
                  Outfitter-jahtimaksut
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="home-container12">
          <div class="home-container13">
            <DangerousHTML
              html=" <iframe id='JotFormIFrame-240100782243343' title='Kanadankarhumatkat.fi' onload='window.parent.scrollTo(0,0)' allowtransparency='true' allowfullscreen='true' allow='geolocation; microphone; camera' src='https://form.jotform.com/240100782243343' frameborder='0' style='min-width:100%;max-width:100%;height:539px;border:none;' scrolling='no' > </iframe> <script type='text/javascript'> var ifr = document.getElementById('JotFormIFrame-240100782243343'); if (ifr) { var src = ifr.src; var iframeParams = []; if (window.location.href && window.location.href.indexOf('?') > -1) { iframeParams = iframeParams.concat(window.location.href.substr(window.location.href.indexOf('?') + 1).split('&')); } if (src && src.indexOf('?') > -1) { iframeParams = iframeParams.concat(src.substr(src.indexOf('?') + 1).split('&')); src = src.substr(0, src.indexOf('?')) } iframeParams.push('isIframeEmbed=1'); ifr.src = src + '?' + iframeParams.join('&'); } window.handleIFrameMessage = function(e) { if (typeof e.data === 'object') { return; } var args = e.data.split(':'); if (args.length > 2) { iframe = document.getElementById('JotFormIFrame-' + args[(args.length - 1)]); } else { iframe = document.getElementById('JotFormIFrame'); } if (!iframe) { return; } switch (args[0]) { case 'scrollIntoView': iframe.scrollIntoView(); break; case 'setHeight': iframe.style.height = args[1] + 'px'; if (!isNaN(args[1]) && parseInt(iframe.style.minHeight) > parseInt(args[1])) { iframe.style.minHeight = args[1] + 'px'; } break; case 'collapseErrorPage': if (iframe.clientHeight > window.innerHeight) { iframe.style.height = window.innerHeight + 'px'; } break; case 'reloadPage': window.location.reload(); break; case 'loadScript': if( !window.isPermitted(e.origin, ['jotform.com', 'jotform.pro']) ) { break; } var src = args[1]; if (args.length > 3) { src = args[1] + ':' + args[2]; } var script = document.createElement('script'); script.src = src; script.type = 'text/javascript'; document.body.appendChild(script); break; case 'exitFullscreen': if (window.document.exitFullscreen) window.document.exitFullscreen(); else if (window.document.mozCancelFullScreen) window.document.mozCancelFullScreen(); else if (window.document.mozCancelFullscreen) window.document.mozCancelFullScreen(); else if (window.document.webkitExitFullscreen) window.document.webkitExitFullscreen(); else if (window.document.msExitFullscreen) window.document.msExitFullscreen(); break; } var isJotForm = (e.origin.indexOf('jotform') > -1) ? true : false; if(isJotForm && 'contentWindow' in iframe && 'postMessage' in iframe.contentWindow) { var urls = {'docurl':encodeURIComponent(document.URL),'referrer':encodeURIComponent(document.referrer)}; iframe.contentWindow.postMessage(JSON.stringify({'type':'urls','value':urls}), '*'); } }; window.isPermitted = function(originUrl, whitelisted_domains) { var url = document.createElement('a'); url.href = originUrl; var hostname = url.hostname; var result = false; if( typeof hostname !== 'undefined' ) { whitelisted_domains.forEach(function(element) { if( hostname.slice((-1 * element.length - 1)) === '.'.concat(element) || hostname === element ) { result = true; } }); return result; } }; if (window.addEventListener) { window.addEventListener('message', handleIFrameMessage, false); } else if (window.attachEvent) { window.attachEvent('onmessage', handleIFrameMessage); } </script>"
            ></DangerousHTML>
          </div>
        </div>
      </div>
    </div>
    <div class="home-faq">
      <div class="home-faq-container">
        <div class="home-faq1">
          <div class="home-container14">
            <span class="home-text26 sectionTitle">
              <span>FAQ</span>
              <br />
            </span>
            <h2 class="home-text29 heading2">Common questions</h2>
            <span class="home-text30">
              <span>Here are some of the most common questions that we get.</span>
              <br />
              <span>
                <span>
                  <span><span v-html="rawzdv2"></span></span>
                  <span><span v-html="raw1rc0"></span></span>
                </span>
                <span>
                  <span><span v-html="rawmign"></span></span>
                  <span><span v-html="rawfjx5"></span></span>
                </span>
              </span>
              <span>
                <span>
                  <span><span v-html="rawzfxc"></span></span>
                  <span><span v-html="rawbtyd"></span></span>
                </span>
                <span>
                  <span><span v-html="rawzmz6"></span></span>
                  <span><span v-html="rawxkgn"></span></span>
                </span>
              </span>
            </span>
          </div>
          <div class="home-container15">
            <app-question
              Answer="We offer trips for bear hunting and fishing in Canada."
              Question="What types of trips do you offer?"
            ></app-question>
            <app-question
              Answer="Our trips are available in various locations across Canada."
              Question="Where in Canada do you offer these trips?"
            ></app-question>
            <app-question
              Answer="Our trip package includes accommodations, meals, transportation, and guided hunting/fishing."
              Question="What is included in the trip package?"
            ></app-question>
            <app-question
              Answer="Yes, you will need a valid hunting or fishing license, which can be obtained through the appropriate authorities."
              Question="Do I need a license for bear hunting or fishing?"
            ></app-question>
            <app-question
              Answer="Yes, participants must be at least 18 years old to join our bear hunting and fishing trips."
              Question="Are there any age restrictions for participating in the trips?"
            ></app-question>
          </div>
        </div>
      </div>
    </div>
    <div class="home-footer">
      <footer class="home-footer1">
        <div class="home-container16">
          <nav class="home-nav">
            <span class="home-nav1">Home</span>
            <span class="home-nav2">Trips</span>
            <span class="home-nav3">Hunting</span>
            <span class="home-nav4">Fishing</span>
            <span class="home-nav5">About</span>
          </nav>
        </div>
        <div class="home-container17">
          <span class="home-text47">© Kanadankarhumatkat.fi</span>
          <div class="home-icon-group">
            <svg viewBox="0 0 950.8571428571428 1024" class="home-icon">
              <path
                d="M925.714 233.143c-25.143 36.571-56.571 69.143-92.571 95.429 0.571 8 0.571 16 0.571 24 0 244-185.714 525.143-525.143 525.143-104.571 0-201.714-30.286-283.429-82.857 14.857 1.714 29.143 2.286 44.571 2.286 86.286 0 165.714-29.143 229.143-78.857-81.143-1.714-149.143-54.857-172.571-128 11.429 1.714 22.857 2.857 34.857 2.857 16.571 0 33.143-2.286 48.571-6.286-84.571-17.143-148-91.429-148-181.143v-2.286c24.571 13.714 53.143 22.286 83.429 23.429-49.714-33.143-82.286-89.714-82.286-153.714 0-34.286 9.143-65.714 25.143-93.143 90.857 112 227.429 185.143 380.571 193.143-2.857-13.714-4.571-28-4.571-42.286 0-101.714 82.286-184.571 184.571-184.571 53.143 0 101.143 22.286 134.857 58.286 41.714-8 81.714-23.429 117.143-44.571-13.714 42.857-42.857 78.857-81.143 101.714 37.143-4 73.143-14.286 106.286-28.571z"
              ></path></svg
            ><svg viewBox="0 0 877.7142857142857 1024" class="home-icon2">
              <path
                d="M585.143 512c0-80.571-65.714-146.286-146.286-146.286s-146.286 65.714-146.286 146.286 65.714 146.286 146.286 146.286 146.286-65.714 146.286-146.286zM664 512c0 124.571-100.571 225.143-225.143 225.143s-225.143-100.571-225.143-225.143 100.571-225.143 225.143-225.143 225.143 100.571 225.143 225.143zM725.714 277.714c0 29.143-23.429 52.571-52.571 52.571s-52.571-23.429-52.571-52.571 23.429-52.571 52.571-52.571 52.571 23.429 52.571 52.571zM438.857 152c-64 0-201.143-5.143-258.857 17.714-20 8-34.857 17.714-50.286 33.143s-25.143 30.286-33.143 50.286c-22.857 57.714-17.714 194.857-17.714 258.857s-5.143 201.143 17.714 258.857c8 20 17.714 34.857 33.143 50.286s30.286 25.143 50.286 33.143c57.714 22.857 194.857 17.714 258.857 17.714s201.143 5.143 258.857-17.714c20-8 34.857-17.714 50.286-33.143s25.143-30.286 33.143-50.286c22.857-57.714 17.714-194.857 17.714-258.857s5.143-201.143-17.714-258.857c-8-20-17.714-34.857-33.143-50.286s-30.286-25.143-50.286-33.143c-57.714-22.857-194.857-17.714-258.857-17.714zM877.714 512c0 60.571 0.571 120.571-2.857 181.143-3.429 70.286-19.429 132.571-70.857 184s-113.714 67.429-184 70.857c-60.571 3.429-120.571 2.857-181.143 2.857s-120.571 0.571-181.143-2.857c-70.286-3.429-132.571-19.429-184-70.857s-67.429-113.714-70.857-184c-3.429-60.571-2.857-120.571-2.857-181.143s-0.571-120.571 2.857-181.143c3.429-70.286 19.429-132.571 70.857-184s113.714-67.429 184-70.857c60.571-3.429 120.571-2.857 181.143-2.857s120.571-0.571 181.143 2.857c70.286 3.429 132.571 19.429 184 70.857s67.429 113.714 70.857 184c3.429 60.571 2.857 120.571 2.857 181.143z"
              ></path></svg
            ><svg viewBox="0 0 602.2582857142856 1024" class="home-icon4">
              <path
                d="M548 6.857v150.857h-89.714c-70.286 0-83.429 33.714-83.429 82.286v108h167.429l-22.286 169.143h-145.143v433.714h-174.857v-433.714h-145.714v-169.143h145.714v-124.571c0-144.571 88.571-223.429 217.714-223.429 61.714 0 114.857 4.571 130.286 6.857z"
              ></path>
            </svg>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import DangerousHTML from 'dangerous-html/vue'

import AppQuestion from '../components/question'

export default {
  name: 'Home',
  components: {
    DangerousHTML,
    AppQuestion,
  },
  data() {
    return {
      rawzdv2: ' ',
      raw1rc0: ' ',
      rawmign: ' ',
      rawfjx5: ' ',
      rawzfxc: ' ',
      rawbtyd: ' ',
      rawzmz6: ' ',
      rawxkgn: ' ',
    }
  },
  metaInfo: {
    title: 'Kanadankarhumatkat',
    meta: [
      {
        name: 'description',
        content: 'Opastettuja karhunmetsästysmatkoja Kanadaan.',
      },
      {
        property: 'og:title',
        content: 'Kanadankarhumatkat',
      },
      {
        property: 'og:description',
        content: 'Opastettuja karhunmetsästysmatkoja Kanadaan.',
      },
    ],
  },
}
</script>

<style scoped>
.home-container {
  width: 100%;
  display: flex;
  overflow: auto;
  min-height: 100vh;
  align-items: center;
  flex-direction: column;
}
.home-hero {
  flex: 0 0 auto;
  width: 100%;
  height: auto;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  background-color: #be1e1e;
}
.home-hero1 {
  width: 100%;
  height: 377px;
  display: flex;
  max-width: var(--dl-size-size-maxwidth);
  min-height: auto;
  align-items: center;
  padding-top: var(--dl-space-space-sixunits);
  border-style: hidden;
  border-width: 1px;
  padding-left: var(--dl-space-space-threeunits);
  padding-right: var(--dl-space-space-threeunits);
  flex-direction: column;
  padding-bottom: var(--dl-space-space-sixunits);
  justify-content: center;
  background-color: #be1e1e;
}
.home-container01 {
  gap: var(--dl-space-space-twounits);
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;
}
.home-hero-sub-heading {
  color: var(--dl-color-gray-white);
  font-size: 40px;
  text-align: center;
  line-height: 1.6;
}
.home-hero-sub-heading1 {
  color: var(--dl-color-gray-white);
  font-size: 18px;
  text-align: center;
  line-height: 1.6;
}
.home-details {
  flex: 0 0 auto;
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.home-details1 {
  width: 100%;
  display: flex;
  max-width: var(--dl-size-size-maxwidth);
  align-items: center;
  padding-top: var(--dl-space-space-fourunits);
  padding-left: var(--dl-space-space-threeunits);
  padding-right: var(--dl-space-space-threeunits);
  padding-bottom: var(--dl-space-space-fourunits);
  justify-content: space-between;
}
.home-container02 {
  flex: 1;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;
}
.home-text05 {
  color: #f5282b;
  text-align: left;
  font-family: "Raleway";
  margin-bottom: var(--dl-space-space-oneandhalfunits);
}
.home-details-heading {
  width: 80%;
  text-align: left;
  font-family: "Raleway";
  line-height: 1.6;
  margin-bottom: var(--dl-space-space-oneandhalfunits);
}
.home-details-sub-heading {
  color: var(--dl-color-gray-800);
  font-size: 18px;
  text-align: left;
  line-height: 1.6;
  margin-bottom: var(--dl-space-space-twounits);
}
.home-details-image {
  width: 400px;
  height: 400px;
  object-fit: cover;
  margin-left: var(--dl-space-space-fourunits);
  border-radius: var(--dl-radius-radius-round);
}
.home-details2 {
  flex: 0 0 auto;
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.home-details3 {
  width: 100%;
  display: flex;
  max-width: var(--dl-size-size-maxwidth);
  align-items: center;
  padding-top: var(--dl-space-space-fourunits);
  padding-left: var(--dl-space-space-threeunits);
  padding-right: var(--dl-space-space-threeunits);
  padding-bottom: var(--dl-space-space-fourunits);
  justify-content: space-between;
}
.home-container03 {
  flex: 1;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;
}
.home-text12 {
  color: #f5282b;
  text-align: left;
  font-family: "Raleway";
  margin-bottom: var(--dl-space-space-oneandhalfunits);
}
.home-details-heading1 {
  width: 80%;
  text-align: left;
  font-family: "Raleway";
  line-height: 1.6;
  margin-bottom: var(--dl-space-space-oneandhalfunits);
}
.home-details-sub-heading1 {
  color: var(--dl-color-gray-800);
  font-size: 18px;
  text-align: left;
  line-height: 1.6;
  margin-bottom: var(--dl-space-space-twounits);
}
.home-details-image1 {
  width: 400px;
  height: 400px;
  object-fit: cover;
  margin-left: var(--dl-space-space-fourunits);
  border-radius: var(--dl-radius-radius-round);
}
.home-pricing {
  flex: 0 0 auto;
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.home-pricing1 {
  gap: var(--dl-space-space-twounits);
  width: 100%;
  display: flex;
  align-items: center;
  padding-top: var(--dl-space-space-fourunits);
  padding-left: var(--dl-space-space-threeunits);
  padding-right: var(--dl-space-space-threeunits);
  flex-direction: column;
  justify-content: center;
  background-color: var(--dl-color-gray-white);
}
.home-container04 {
  gap: var(--dl-space-space-twounits);
  width: 100%;
  display: flex;
  max-width: var(--dl-size-size-maxwidth);
  align-items: flex-start;
  justify-content: center;
}
.home-pricing-card {
  gap: var(--dl-space-space-twounits);
  width: 982px;
  display: flex;
  padding: var(--dl-space-space-twounits);
  max-width: 600px;
  min-height: 450px;
  align-items: flex-start;
  border-radius: var(--dl-radius-radius-radius8);
  flex-direction: column;
  background-color: #f7e4ab;
}
.home-container05 {
  gap: var(--dl-space-space-oneandhalfunits);
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;
}
.home-text20 {
  font-family: "Raleway";
  font-weight: bold;
  text-transform: uppercase;
}
.home-basic-plan-description {
  line-height: 1.6;
}
.home-container06 {
  display: flex;
  align-items: center;
  margin-bottom: var(--dl-space-space-twounits);
  flex-direction: row;
}
.home-basic-plan-pricing {
  font-size: 4rem;
  font-weight: 700;
}
.home-container07 {
  width: 100%;
  display: flex;
  align-items: flex-start;
  margin-bottom: var(--dl-space-space-threeunits);
  flex-direction: column;
}
.home-container08 {
  gap: 4px;
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  align-items: flex-start;
  margin-bottom: var(--dl-space-space-unit);
  flex-direction: row;
}
.home-text21 {
  color: var(--dl-color-gray-800);
}
.home-text22 {
  color: var(--dl-color-gray-800);
}
.home-container09 {
  gap: 4px;
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  align-items: flex-start;
  margin-bottom: var(--dl-space-space-unit);
  flex-direction: row;
}
.home-text23 {
  color: var(--dl-color-gray-800);
}
.home-basic-plan-features {
  color: var(--dl-color-gray-800);
  line-height: 1.6;
}
.home-container10 {
  gap: 4px;
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  align-items: flex-start;
  margin-bottom: var(--dl-space-space-unit);
  flex-direction: row;
}
.home-text24 {
  color: var(--dl-color-gray-800);
}
.home-basic-plan-features1 {
  color: var(--dl-color-gray-800);
  line-height: 1.6;
}
.home-container11 {
  gap: 4px;
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  align-items: flex-start;
  margin-bottom: var(--dl-space-space-unit);
  flex-direction: row;
}
.home-text25 {
  color: var(--dl-color-gray-800);
}
.home-basic-plan-features2 {
  color: var(--dl-color-gray-800);
  line-height: 1.6;
}
.home-container12 {
  width: 100%;
  height: 582px;
}
.home-container13 {
  display: contents;
}
.home-faq {
  flex: 0 0 auto;
  width: 100%;
  height: auto;
  display: none;
  align-items: center;
  justify-content: center;
}
.home-faq-container {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
}
.home-faq1 {
  gap: var(--dl-space-space-twounits);
  width: 100%;
  display: flex;
  max-width: var(--dl-size-size-maxwidth);
  align-items: flex-start;
  padding-top: var(--dl-space-space-fourunits);
  padding-left: var(--dl-space-space-threeunits);
  padding-right: var(--dl-space-space-threeunits);
  flex-direction: row;
  padding-bottom: var(--dl-space-space-fourunits);
}
.home-container14 {
  display: flex;
  max-width: 35%;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;
}
.home-text26 {
  color: var(--dl-color-primary1-blue80);
  font-family: "Raleway";
  margin-bottom: var(--dl-space-space-oneandhalfunits);
}
.home-text29 {
  font-family: "Raleway";
  line-height: 1.6;
  margin-bottom: var(--dl-space-space-oneandhalfunits);
}
.home-text30 {
  color: var(--dl-color-gray-800);
  font-size: 18px;
  text-align: left;
  line-height: 1.6;
}
.home-container15 {
  gap: var(--dl-space-space-oneandhalfunits);
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.home-footer {
  flex: 0 0 auto;
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}
.home-footer1 {
  width: 100%;
  display: flex;
  max-width: var(--dl-size-size-maxwidth);
  align-items: center;
  padding-top: var(--dl-space-space-fourunits);
  padding-left: var(--dl-space-space-threeunits);
  padding-right: var(--dl-space-space-threeunits);
  flex-direction: column;
  padding-bottom: var(--dl-space-space-fourunits);
  justify-content: space-between;
}
.home-container16 {
  gap: var(--dl-space-space-oneandhalfunits);
  display: flex;
  max-width: var(--dl-size-size-maxwidth);
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;
}
.home-nav {
  flex: 0 0 auto;
  display: none;
  margin-top: 0px;
  align-items: center;
  flex-direction: row;
}
.home-nav1 {
  color: var(--dl-color-secondary-gray500);
  margin-left: 0px;
}
.home-nav2 {
  color: var(--dl-color-secondary-gray500);
  margin-left: var(--dl-space-space-unit);
}
.home-nav3 {
  color: var(--dl-color-secondary-gray500);
  margin-left: var(--dl-space-space-unit);
}
.home-nav4 {
  color: var(--dl-color-secondary-gray500);
  margin-left: var(--dl-space-space-unit);
}
.home-nav5 {
  color: var(--dl-color-secondary-gray500);
  margin-left: var(--dl-space-space-unit);
}
.home-container17 {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
}
.home-text47 {
  color: var(--dl-color-secondary-gray500);
}
.home-icon-group {
  display: none;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
}
.home-icon {
  fill: var(--dl-color-secondary-gray500);
  width: 24px;
  height: 24px;
  margin-right: var(--dl-space-space-twounits);
}
.home-icon2 {
  fill: var(--dl-color-secondary-gray500);
  width: 24px;
  height: 24px;
  margin-right: var(--dl-space-space-twounits);
}
.home-icon4 {
  fill: var(--dl-color-secondary-gray500);
  width: 24px;
  height: 24px;
}
@media(max-width: 991px) {
  .home-hero1 {
    flex-direction: column;
  }
  .home-container01 {
    align-items: center;
    margin-right: 0px;
    margin-bottom: var(--dl-space-space-twounits);
    padding-right: 0px;
  }
  .home-hero-sub-heading {
    text-align: center;
    padding-left: var(--dl-space-space-threeunits);
    padding-right: var(--dl-space-space-threeunits);
  }
  .home-hero-sub-heading1 {
    text-align: center;
    padding-left: var(--dl-space-space-threeunits);
    padding-right: var(--dl-space-space-threeunits);
  }
  .home-details-sub-heading {
    text-align: center;
    padding-left: var(--dl-space-space-threeunits);
    padding-right: var(--dl-space-space-threeunits);
  }
  .home-details-sub-heading1 {
    text-align: center;
    padding-left: var(--dl-space-space-threeunits);
    padding-right: var(--dl-space-space-threeunits);
  }
  .home-text15 {
    text-align: center;
    padding-left: var(--dl-space-space-threeunits);
    padding-right: var(--dl-space-space-threeunits);
  }
  .home-container04 {
    align-items: center;
    flex-direction: column;
  }
  .home-pricing-card {
    width: 100%;
    max-width: 450px;
  }
  .home-container12 {
    width: 100%;
    height: 558px;
  }
  .home-text30 {
    text-align: center;
    padding-left: var(--dl-space-space-threeunits);
    padding-right: var(--dl-space-space-threeunits);
  }
}
@media(max-width: 767px) {
  .home-hero {
    height: 100%;
  }
  .home-hero1 {
    height: 100%;
    max-width: 100%;
    min-height: 100%;
    padding-left: var(--dl-space-space-twounits);
    padding-right: var(--dl-space-space-twounits);
  }
  .home-container01 {
    width: 100%;
    height: 100%;
  }
  .home-hero-sub-heading {
    color: var(--dl-color-gray-white);
    width: 100%;
    height: 100%;
    font-size: 30px;
    font-style: normal;
    font-weight: 700;
    line-height: 1.6;
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
  }
  .home-hero-sub-heading1 {
    width: 100%;
    height: 100%;
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
  }
  .home-details1 {
    align-items: center;
    padding-left: var(--dl-space-space-twounits);
    padding-right: var(--dl-space-space-twounits);
    flex-direction: column;
    justify-content: center;
  }
  .home-container02 {
    align-items: center;
    justify-content: flex-start;
  }
  .home-text05 {
    text-align: center;
  }
  .home-details-heading {
    text-align: center;
  }
  .home-details-sub-heading {
    text-align: center;
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
  }
  .home-details-image {
    margin-top: var(--dl-space-space-threeunits);
    margin-left: 0px;
  }
  .home-details3 {
    align-items: center;
    padding-left: var(--dl-space-space-twounits);
    padding-right: var(--dl-space-space-twounits);
    flex-direction: column;
    justify-content: center;
  }
  .home-container03 {
    align-items: center;
    justify-content: flex-start;
  }
  .home-text12 {
    text-align: center;
  }
  .home-details-heading1 {
    text-align: center;
  }
  .home-details-sub-heading1 {
    text-align: center;
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
  }
  .home-text15 {
    text-align: center;
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
  }
  .home-details-image1 {
    margin-top: var(--dl-space-space-threeunits);
    margin-left: 0px;
  }
  .home-pricing1 {
    padding-left: var(--dl-space-space-twounits);
    padding-right: var(--dl-space-space-twounits);
  }
  .home-container04 {
    align-items: center;
    flex-direction: column;
  }
  .home-pricing-card {
    width: 100%;
    max-width: 450px;
    margin-right: 0px;
    margin-bottom: var(--dl-space-space-twounits);
  }
  .home-container12 {
    width: 100%;
    height: 526px;
  }
  .home-faq1 {
    padding-left: var(--dl-space-space-twounits);
    padding-right: var(--dl-space-space-twounits);
    flex-direction: column;
  }
  .home-container14 {
    max-width: 100%;
    align-self: center;
    align-items: center;
    justify-content: center;
  }
  .home-text30 {
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
  }
  .home-footer1 {
    padding-left: var(--dl-space-space-twounits);
    padding-right: var(--dl-space-space-twounits);
  }
  .home-container17 {
    align-items: center;
    flex-direction: column;
    justify-content: space-between;
  }
  .home-text47 {
    margin-bottom: var(--dl-space-space-oneandhalfunits);
  }
}
@media(max-width: 479px) {
  .home-hero {
    height: 100%;
  }
  .home-hero1 {
    width: auto;
    height: auto;
    padding-top: var(--dl-space-space-twounits);
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
    padding-bottom: var(--dl-space-space-twounits);
  }
  .home-container01 {
    margin-bottom: var(--dl-space-space-unit);
  }
  .home-hero-sub-heading {
    color: var(--dl-color-gray-white);
    width: auto;
    font-size: 30px;
    line-height: 1.6;
  }
  .home-hero-sub-heading1 {
    width: auto;
  }
  .home-basic-plan-pricing {
    font-size: 2rem;
  }
  .home-container12 {
    width: 100%;
    height: 545px;
    margin-bottom: 0px;
  }
  .home-footer1 {
    padding: var(--dl-space-space-unit);
  }
  .home-container17 {
    align-items: center;
    flex-direction: column;
    justify-content: space-between;
  }
  .home-text47 {
    text-align: center;
    margin-bottom: var(--dl-space-space-oneandhalfunits);
  }
}
</style>
